var map = {
	"./EmptyLayout.vue": [
		66496,
		697,
		7980,
		6643
	],
	"./MainLayout.vue": [
		43676,
		3385,
		1344,
		697,
		9147,
		4490,
		7980,
		921
	],
	"./components/MyFooter.vue": [
		60697,
		697,
		9108
	],
	"./components/MyHeaderLang.vue": [
		81135,
		7980,
		6469
	],
	"./components/MyHeaderNav.vue": [
		3135,
		3385,
		1344,
		3135
	],
	"./components/MyInternetError.vue": [
		44485,
		4485
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2115;
module.exports = webpackAsyncContext;